export default __webpack_public_path__ + "static/media/play-btn.1aab0975.svg";